/**********************************************
 * SlideToggle: custom element
 * - Mostra/nasconde campi extra
 * - Gestisce attributi required
 * - Se l'utente seleziona "no", rimuove le property
 *   associate (usando CartPropertiesStore) e
 *   (opzionale) rimuove anche l'item dal carrello
 **********************************************/
class Slidetoggle extends HTMLElement {
  constructor() {
    super();

    this.inputYes = this.querySelector('input[value="yes"]');
    this.inputNo = this.querySelector('input[value="no"]');
    this.extraFields = this.querySelector('.extra-fields');
    this.extraCustomFields = this.extraFields.querySelectorAll('custom-field');
    this.group = this.querySelector('.field-group--companion');
    this.guestSection = this.closest('slide-toggle').querySelector('.field-group--companion');
    this.guestForm = this.closest('slide-toggle').querySelector('product-form');

    // Gestiamo i radio button: yes/no
    this.inputYes.addEventListener('change', e => this.onToggle(e));
    this.inputNo.addEventListener('change', e => this.onToggle(e));

    // All'inizio, se la sezione è "aperta", sistemiamo l'altezza
    this.checkOpenedFields();
  }

  /**********************************************
   * Se la sezione extra-fields è già aperta,
   * settiamo l'altezza per animazione, ecc.
   **********************************************/
  checkOpenedFields() {
    const isOpened = this.extraFields.classList.contains('extra-fields--opened');
    if (isOpened) {
      this.setHeight(this.group.offsetHeight);
    }
  }

  /**********************************************
   * onToggle: quando l'utente sceglie "yes" o "no"
   **********************************************/
  async onToggle(event) {
    const { value, id } = event.currentTarget; // es: value="yes", id="OwnerMaseratiYes_..."

    if (value === 'yes' || (value === 'no' && id.includes('OwnerMaserati'))) {
      // CASO "YES" (o "NO" su OwnerMaserati)
      if (id.includes('OwnerMaserati')) {
        if (value === 'no') {
          this.extraFields.classList.add('extra-fields--opened-no');
          this.extraFields.classList.remove('extra-fields--opened-yes');
        } else if (value === 'yes') {
          this.extraFields.classList.add('extra-fields--opened-yes');
          this.extraFields.classList.remove('extra-fields--opened-no');
        }
      }

      // Apri la sezione
      this.setHeight(this.group.offsetHeight);
      this.extraFields.classList.add('extra-fields--opened');

      // Gestione attributi required
      if (id.includes('OwnerMaserati')) {
        this.toggleRequiredAttributeMaserati(value);
      } else {
        this.toggleRequiredAttribute(true);
      }

    } else {
      // CASO "NO"
      // Chiudi la sezione
      this.setHeight(0);
      this.extraFields.classList.remove('extra-fields--opened');

      // (Opzionale) Rimuove l'item dal carrello
      if (this.guestForm) {
        await this.guestForm.removeProductInSection(this.guestSection);
      }

      // Rimuove i valori dai campi e aggiorna/rimuove le property
      this.clearAndRemoveProperties();

      // Togli il required
      this.toggleRequiredAttribute(false);

      // Aggiorna il drawer (opzionale)
      this.updateCartDrawer();
    }
  }

  /**********************************************
   * clearAndRemoveProperties:
   * - Svuota i campi input
   * - Rimuove le property corrispondenti da
   *   CartPropertiesStore (quindi dagli hidden input).
   **********************************************/
  clearAndRemoveProperties() {
    let propertyNames = [];
    let itemId = null;

    // Svuoto i campi
    this.extraCustomFields.forEach(customFieldEl => {
      const fieldInput = customFieldEl.querySelector('input') || customFieldEl.querySelector('select');
      if (fieldInput) {
        // salvo itemId e propertyName
        itemId = fieldInput.dataset.lineitem; // es. "12345"
        propertyNames.push(fieldInput.name);  // es. "_participant_1_guest_1_name_gt-am"
        // Svuoto il valore
        fieldInput.value = '';
      }
    });

    // Ora chiamo CartPropertiesStore per rimuovere quelle property
    // in modo da rimuovere i <input hidden name="properties[propName]">
    if (itemId && propertyNames.length > 0) {
      // Se la classe CartPropertiesStore è caricata come globale
      // la puoi usare come `window.CartPropertiesStore` oppure
      // semplicemente `CartPropertiesStore` se non stai usando import/export
      CartPropertiesStore.removeProperties(itemId, propertyNames);
    }
  }

  /**********************************************
   * Aggiorna il cart drawer (opzionale)
   **********************************************/
  async updateCartDrawer() {
    const cart = document.querySelector('cart-drawer');
    if (!cart) return;

    const response = await fetch('/cart?sections=cart-drawer');
    const html = await response.text();
    const newDocument = new DOMParser().parseFromString(html, 'text/html');

    const sections = cart.getSectionsToRender();
    sections.forEach((section) => {
      const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

      const newSectionElement = newDocument.querySelector(section.selector || `#${section.id}`);
      if (sectionElement && newSectionElement) {
        sectionElement.innerHTML = newSectionElement.innerHTML;
      }
    });

    // Rimuovo "is-empty" se c'è
    const drawerInner = cart.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }
  }

  /**********************************************
   * setHeight: animazione per l'apertura
   **********************************************/
  setHeight(offsetHeight) {
    this.extraFields.style.height = `${offsetHeight}px`;
  }

  /**********************************************
   * toggleRequiredAttribute:
   * aggiunge o rimuove l'attributo required
   **********************************************/
  toggleRequiredAttribute(status) {
    this.extraFields.querySelectorAll('input, select').forEach(element => {
      if (element.type !== 'hidden') {
        if (status) {
          element.setAttribute('required', 'required');
        } else {
          element.removeAttribute('required');
        }
      }
    });
  }

  /**********************************************
   * toggleRequiredAttributeMaserati:
   * se l'utente sceglie yes/no su "OwnerMaserati",
   * imposta required su determinati campi
   **********************************************/
  toggleRequiredAttributeMaserati(status) {
    // Se status="yes", campi con class="field yes" vanno in required
    // Se status="no", campi con class="field no" vanno in required
    // (adatta se la tua logica è diversa)
    const maseratiExtraFields = this.extraFields.querySelectorAll(`.field.${status}`);
    maseratiExtraFields.forEach(field => {
      field.querySelectorAll('input, select').forEach(element => {
        element.setAttribute('required', 'required');
      });
    });
  }
}

customElements.define('slide-toggle', Slidetoggle);
